export default __webpack_public_path__ + "static/media/icon_404@2x.de356f43.png";